import { Card } from 'entities/card/model/types';
import { api } from 'shared/api';
import { BlockReason } from 'features/card/block-card/model/types';
import { ApiResponse } from 'shared/model/types';

const blockCardApi = api.injectEndpoints({
  endpoints: (build) => ({
    block: build.mutation<
      ApiResponse<Partial<Card>>,
      {
        accountId: number;
        cardId: number;
        reason: BlockReason;
      }
    >({
      query: ({ accountId, cardId, reason }) => ({
        url: `private/river/${accountId}/card/${cardId}/hard-block`,
        method: 'POST',
        params: { reason },
      }),
    }),
  }),
});

export const { useBlockMutation } = blockCardApi;

export default blockCardApi;
